import React from 'react';

import Dog from '@rover/icons/svg/dog.svg';
import Grooming from '@rover/icons/svg/grooming.svg';
import Trophy from '@rover/icons/svg/trophy.svg';
import { Flex, Text } from '@rover/kibble/core';

import { RATE_SIZE_INFO } from '../../../../GroomingServicePage/constants';

const ICON_SIZE = 16;

interface GroomingDetailsSectionProps {
  yearsOfExperience: string;
  isHosting: boolean;
  isTraveling: boolean;
  supportedPetSizes: string[];
}

function getTravelingText(isHosting: boolean, isTraveling: boolean): string | null {
  if (isHosting && isTraveling) return 'Travels to your home, grooms at their home';
  if (isHosting) return 'Grooms at their home';
  if (isTraveling) return 'Travels to your home';
  return null;
}

function GroomingDetailsSection({
  yearsOfExperience,
  isHosting,
  isTraveling,
  supportedPetSizes,
}: GroomingDetailsSectionProps): JSX.Element {
  const travelingText = getTravelingText(isHosting, isTraveling);

  const showExperience = !!parseInt(yearsOfExperience, 10);

  const supportedSizeLabels = supportedPetSizes
    .map((size) => RATE_SIZE_INFO[size]?.label)
    .filter(Boolean);
  const supportedSizeText =
    supportedSizeLabels.length > 0 ? `Works with: ${supportedSizeLabels.join(', ')}` : '';

  return (
    <Flex flexDirection="column" gap="3x">
      {showExperience && (
        <Flex gap="1x" alignItems="center">
          <Trophy width={ICON_SIZE} height={ICON_SIZE} />
          <Text size="100">
            {parseInt(yearsOfExperience, 10) === 1
              ? `${yearsOfExperience} year of experience`
              : `${yearsOfExperience} years of experience`}
          </Text>
        </Flex>
      )}
      {supportedSizeText && (
        <Flex gap="1x" alignItems="center">
          <Dog width={ICON_SIZE} height={ICON_SIZE} />
          <Text size="100">{supportedSizeText}</Text>
        </Flex>
      )}
      {travelingText && (
        <Flex gap="1x" alignItems="center">
          <Grooming width={ICON_SIZE} height={ICON_SIZE} />
          <Text size="100">{travelingText}</Text>
        </Flex>
      )}
    </Flex>
  );
}

export default GroomingDetailsSection;
